/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CLog, { LogTypes } from '../../ComponentLogger';
import UpdateableComponentBase from './UpdateableComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/**
 * Implementation of [[UpdateableComponentBase]] for hiding or showing a [[cc.Node]] based on the target observable.
 */
@cc._decorator.ccclass
export default class UpdateableSpriteComponent extends UpdateableComponentBase<cc.Sprite, number>
{
    /** Should this component be hidden when the observable is at its minimum value. */
    @property({ visible: true })
    private _hideOnMinValue: boolean = false;

    /** Should this component be hidden when the observable is at its maximum value. */
    @property({ visible: true })
    private _hideOnMaxValue: boolean = false;

    /** The [[cc.Sprite]] to show or hide based on the observable's value. */
    protected component: cc.Sprite;

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this.component = this.node.getComponent(cc.Sprite);

        if (!this.component)
        {
            CLog.error("No sprite component. Disabled.", this, LogTypes.Initialization);
            this.enabled = false;
            return;
        }
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        if (!this.observable)
        {
            this.node.active = false;
        }
    }

    /** @hidden */
    protected updateUI = (event?: cc.Event.EventCustom): void =>
    {
        if (!this.observable)
        {
            this.node.active = false;
            return;
        }

        if (this._hideOnMinValue && this.observable.Value === this.observable.MinValue)
        {
            this.node.active = false;
        }
        else if (this._hideOnMaxValue && this.observable.Value === this.observable.MaxValue)
        {
            this.node.active = false;
        }
        else
        {
            this.node.active = true;
        }
    }
}
